import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import { Page, Spinner, Text } from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import React, { useState, useCallback, useEffect } from "react";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const Board = () => {
  const navigate = useNavigate();
  const [columns, setColumns] = useState(null);
  var randomColor = require("randomcolor");
  const [statuses, setStatuses] = useState(null);
  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    let responseContacts = "";
    let responseStatuses = "";

    try {
      responseContacts = await axios.get(`/crm/contacts?sort=order`);
    } catch (error) {
      console.log(error);
    }

    try {
      responseStatuses = await axios.get(`/crm/statuses`);
      setStatuses(
        responseStatuses?.data?.data?.data.map((item, index) => {
          return {
            id: index,
            value: item.id,
          };
        })
      );
      let array = [];
      for (var i = 0; i < responseContacts.data.data.data.length; i++) {
        let colorObjBgd = randomColor({
          format: "rgba",
          alpha: 0.4,
        });

        let colorObjTxt = `rgba(
            ${rgbToObj(colorObjBgd).red},
            ${rgbToObj(colorObjBgd).green},
            ${rgbToObj(colorObjBgd).blue},
            1
            
          )`;

        array.push({
          id: responseContacts.data.data.data[i].id,
          bgdColor: colorObjBgd,
          textColor: colorObjTxt,
        });
      }
      console.log(
        "test=",
        responseContacts.data.data.data.filter((item) => item.status !== null)
      );
      setColumns(
        responseStatuses?.data?.data?.data.map((item, index) => {
          return {
            id: index,
            name: capitalizeFirstLowercaseRest(item.name),
            items: responseContacts.data.data.data
              .filter((item) => item.status !== null)
              .filter(({ status }) => status.name === item.name)
              .map((element, index) => {
                return {
                  id: item.name + "_" + index + "_" + element.id,
                  content: (
                    <div>
                      <div className="rowDiv nameBoard mt-3 mb-4">
                        {/* <div>{element.id}</div> */}
                        <div
                          className={
                            (element?.first_name || element?.last_name) &&
                            "circle row_click centered-element"
                          }
                          style={{
                            backgroundColor: array.find(
                              (x) => x.id === element.id
                            ).bgdColor,
                          }}
                        >
                          <b
                            style={{
                              color: array.find((x) => x.id === element.id)
                                .textColor,
                            }}
                          >
                            {element?.first_name || element?.last_name
                              ? element?.first_name && element?.last_name
                                ? element?.first_name.toUpperCase().charAt(0) +
                                  element?.last_name.toUpperCase().charAt(0)
                                : element?.first_name.toUpperCase().charAt(0) +
                                  element?.first_name.toUpperCase().charAt(1)
                              : ""}
                          </b>
                        </div>
                        <div className="ms-5 centered-element">
                          <Text variant="headingSm" as="h6">
                            {(element?.first_name ? element?.first_name : "") +
                              " " +
                              (element?.last_name ? element?.last_name : "")}
                          </Text>
                        </div>
                      </div>
                      <div className="mt-2">
                        <p className="board-text">
                          Registered:{" "}
                          {moment(item.created_at).format(
                            "YYYY-MM-DD HH:mm:ss"
                          )}
                        </p>
                      </div>
                      <p className="board-text">
                        Email: {element.email ? element.email : "-"}
                      </p>
                      <p className="board-text">
                        Category:{" "}
                        {element.internal_campaign?.name
                          ? element.internal_campaign?.name
                          : "-"}
                      </p>
                      <p className="board-text">
                        Campaign:{" "}
                        {element.internal_campaign?.name
                          ? element.internal_campaign?.name
                          : "-"}
                      </p>
                      <p className="board-text">
                        Comany:
                        {element.company?.name ? element.company?.name : "-"}
                      </p>
                    </div>
                  ),
                };
              }),
          };
        })
      );
    } catch (error) {
      console.log(error);
    }
  }
  const onDragEnd = (result, columns, setColumns) => {
    console.log("result=", result);
    console.log(result.destination.droppableId);
    console.log(
      "test1=",
      findArrayElementById(statuses, result.destination.droppableId).value
    );

    console.log("test2=", result.draggableId.split("_")[2]);
    let bodyObj = {};
    if (!result.destination) return;
    const { source, destination } = result;

    if (source.droppableId !== destination.droppableId) {
      const sourceColumn = columns[source.droppableId];
      const destColumn = columns[destination.droppableId];
      const sourceItems = [...sourceColumn.items];
      const destItems = [...destColumn.items];
      const [removed] = sourceItems.splice(source.index, 1);
      destItems.splice(destination.index, 0, removed);
      console.log("case1SOURCE=", sourceItems);
      console.log("case1DESTINATION=", destItems);
      bodyObj = {
        to_status_id: findArrayElementById(
          statuses,
          result.destination.droppableId
        ).value,
        from_contact_ids: sourceItems.map((item) =>
          parseInt(item.id.split("_")[2])
        ),
        to_contact_ids: destItems.map((item) =>
          parseInt(item.id.split("_")[2])
        ),
      };
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...sourceColumn,
          items: sourceItems,
        },
        [destination.droppableId]: {
          ...destColumn,
          items: destItems,
        },
      });
    } else {
      const column = columns[source.droppableId];
      const copiedItems = [...column.items];
      const [removed] = copiedItems.splice(source.index, 1);
      copiedItems.splice(destination.index, 0, removed);
      console.log("case2=", copiedItems);
      bodyObj = {
        to_status_id: "",
        from_contact_ids: copiedItems.map((item) =>
          parseInt(item.id.split("_")[2])
        ),
        to_contact_ids: [],
      };
      setColumns({
        ...columns,
        [source.droppableId]: {
          ...column,
          items: copiedItems,
        },
      });
    }

    axios
      .post(
        `/crm/contacts/${result.draggableId.split("_")[2]}/order-status/edit`,
        bodyObj
      )
      .then((result) => {
        // setToastContent("The status has been changed successfully");
        // toggleActive();
        // setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const capitalizeFirstLowercaseRest = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  return (
    <Page
      title="Contacts Board"
      fullWidth
      breadcrumbs={[{ onAction: () => navigate(`/admin/crm/contacts`) }]}
    >
      {/* <h1 style={{ textAlign: "center" }}>Jira Board</h1> */}
      {columns ? (
        <div
          style={{
            display: "flex",
            // justifyContent: "center",
            height: "100%",
            // width: "100%",
            // paddingLeft: "5rem",
          }}
        >
          <DragDropContext
            onDragEnd={(result) => onDragEnd(result, columns, setColumns)}
          >
            {Object.entries(columns).map(([columnId, column], index) => {
              return (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                  key={columnId}
                >
                  <h2>{column.name.toUpperCase()}</h2>
                  <div style={{ margin: "8px 8px 8px 0" }}>
                    <Droppable droppableId={columnId} key={columnId}>
                      {(provided, snapshot) => {
                        return (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            style={{
                              background: snapshot.isDraggingOver
                                ? "#ebebeb"
                                : "#ebebeb",
                              padding: 4,
                              width: 250,
                              minHeight: 500,
                              borderRadius: "3px",
                            }}
                          >
                            {column.items.map((item, index) => {
                              return (
                                <Draggable
                                  key={item.id}
                                  draggableId={item.id}
                                  index={index}
                                >
                                  {(provided, snapshot) => {
                                    return (
                                      <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        style={{
                                          userSelect: "none",
                                          padding: 16,
                                          margin: "0 0 4px 0",
                                          minHeight: "50px",
                                          backgroundColor: snapshot.isDragging
                                            ? "#ffffff"
                                            : "#ffffff",
                                          color: "black",
                                          ...provided.draggableProps.style,
                                          borderRadius: "3px",
                                        }}
                                      >
                                        {item.content}
                                      </div>
                                    );
                                  }}
                                </Draggable>
                              );
                            })}
                            {provided.placeholder}
                          </div>
                        );
                      }}
                    </Droppable>
                  </div>
                </div>
              );
            })}
          </DragDropContext>
        </div>
      ) : (
        <div className="spinnerContainer">
          <div className="vertical-center">
            <Spinner size="large" />
          </div>
        </div>
      )}
    </Page>
  );
  function findArrayElementById(array, value) {
    return array.find((element, index) => {
      return parseInt(element.id) === parseInt(value);
    });
  }
  function rgbToObj(rgb) {
    let colors = ["red", "green", "blue", "alpha"];

    let colorArr = rgb
      .slice(rgb.indexOf("(") + 1, rgb.indexOf(")"))
      .split(", ");

    let obj = new Object();

    colorArr.forEach((k, i) => {
      obj[colors[i]] = k;
    });

    return obj;
  }
};

export default Board;
